module.exports = __webpack_public_path__ + "assets/img/4-1.b3cf88ee.svg";